import type { Step } from "react-joyride";

export const promotionRecordDetailTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ໜ້າລາຍລະອຽດບັນທຶກການເລື່ອນຕຳແໜ່ງ. ສະແດງຂໍ້ມູນພະນັກງານ, ຕຳແໜ່ງ, ລະດັບ ແລະ ເງິນເດືອນ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="promotion-record-detail-back"]',
    content:
      "ກັບຄືນໄປຫນ້າລາຍການບັນທຶກການເລື່ອນຕຳແໜ່ງ. ກົດປຸ່ມ ? ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="promotion-record-detail-content"]',
    content:
      "ຂໍ້ມູນລາຍລະອຽດ: ພະນັກງານ, ຕຳແໜ່ງເກົ່າ→ໃໝ່, ລະດັບ, ເງິນເດືອນ, ວັນທີເລື່ອນຂັ້ນ ແລະ ເຫດຜົນ.",
    placement: "top",
  },
];
